// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/list-bullet.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../images/list-bullet-small.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about {
  background-color: white;
  width: 100%;
  padding: 200px 0 200px 0;
  display: flex;
  flex-direction: column;
  margin: 0 auto 0 auto;
  color: rgba(144, 110, 103, 1);
}

.about__all-container {
  max-width: 1386px;
  margin: 0 auto 0 auto;
}

.about__header-container {
  display: flex;
  margin: 0 auto 70px 0;
}

.about__header {
  font-size: 60px;
  font-weight: 500;
  line-height: 50px;
  font-family: "Playfair Display";
  margin: 0 19px 0 0;
  padding: 0;
}

.about__line {
  width: 450px;
  height: 1px;
  background-color: rgba(144, 110, 103, 1);
  margin: 36px 0 0 0;
}

.about__container {
  display: flex;
}

.about__photo {
  width: 583px;
  height: 873px;
  border-radius: 10px;
  margin: 0 122px 0 0;
}

.about__info-container {
  display: flex;
  flex-direction: column;
}

.about__paragraph {
  font-size: 18px;
  font-weight: 500;
  line-height: 30px;
  margin: 0 0 120px 0;
  padding: 0;
}

.about__list {
  list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  margin: 0;
  padding: 0;
  font-size: 20px;
  font-weight: normal;
  line-height: 28px;
  margin: 0 0 0 28px;
  padding: 0;
}

.about__list-item {
  margin: 0 0 25px 0px;
  padding-left: 40px;
}

.about__list-item:last-of-type {
  margin-bottom: 0;
}

@media screen and (max-width: 1439px) {
  .about {
    padding: 100px 0 100px 0;
  }

  .about__container {
    flex-direction: column;
    align-items: center;
  }

  .about__all-container {
    max-width: 984px;
  }

  .about__header-container {
    margin: 0 auto 50px 0;
  }

  .about__header {
    font-size: 45px;
    line-height: 55px;
  }

  .about__line {
    width: 387px;
    margin: 30px 0 0 0;
  }

  .about__photo {
    width: 783px;
    height: 845px;
    object-fit: cover;
    border-radius: 10px;
    margin: 0 auto 32px auto;
  }

  .about__info-container {
    align-items: center;
  }

  .about__paragraph {
    max-width: 660px;
    line-height: 26px;
    margin: 0 0 37px 0;
    text-align: center;
  }

  .about__list {
    max-width: 641px;
    font-size: 18px;
    line-height: 26px;
    margin: 0 0 0 28px;
    padding: 0;
  }
}

@media screen and (max-width: 1023px) {
  .about {
    padding: 75px 0 75px 0;
  }

  .about__all-container {
    max-width: 708px;
  }

  .about__header-container {
    margin: 0 auto 35px 0;
  }

  .about__header {
    font-size: 35px;
    line-height: 45px;
  }

  .about__photo {
    width: 500px;
    height: 550px;
    object-fit: cover;
    border-radius: 10px;
    margin: 0 auto 32px auto;
  }

  .about__paragraph {
    font-size: 16px;
    line-height: 24px;
    margin: 0 0 30px 0;
    text-align: center;
  }

  .about__list {
    font-size: 16px;
    line-height: 18px;
  }
}

@media screen and (max-width: 763px) {
  .about {
    padding: 100px 0 100px 0;
  }

  .about__container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .about__all-container {
    display: flex;
    flex-direction: column;
    max-width: 290px;
    margin: 0 auto 0 auto;
  }

  .about__header-container {
    margin: 0 auto 35px 0;
  }

  .about__header {
    font-size: 26px;
    line-height: 36px;
    margin: 0 37px 0 0;
  }

  .about__line {
    width: 150px;
    margin: 18px 0 0 0;
  }

  .about__photo {
    object-fit: cover;
    width: 247px;
    height: 312px;
    margin: 0 0 41px 0;
  }

  .about__container {
    flex-direction: column;
  }

  .about__paragraph {
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin: 0 0 30px 0;
  }

  .about__list {
    list-style-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    font-size: 16px;
    line-height: 24px;
    margin: 0 0 0 18px;
  }

  .about__list-item {
    margin: 0 0 10px 0px;
    padding-left: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/About/About.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,yDAAqD;EACrD,SAAS;EACT,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yDAA2D;IAC3D,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":[".about {\r\n  background-color: white;\r\n  width: 100%;\r\n  padding: 200px 0 200px 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  margin: 0 auto 0 auto;\r\n  color: rgba(144, 110, 103, 1);\r\n}\r\n\r\n.about__all-container {\r\n  max-width: 1386px;\r\n  margin: 0 auto 0 auto;\r\n}\r\n\r\n.about__header-container {\r\n  display: flex;\r\n  margin: 0 auto 70px 0;\r\n}\r\n\r\n.about__header {\r\n  font-size: 60px;\r\n  font-weight: 500;\r\n  line-height: 50px;\r\n  font-family: \"Playfair Display\";\r\n  margin: 0 19px 0 0;\r\n  padding: 0;\r\n}\r\n\r\n.about__line {\r\n  width: 450px;\r\n  height: 1px;\r\n  background-color: rgba(144, 110, 103, 1);\r\n  margin: 36px 0 0 0;\r\n}\r\n\r\n.about__container {\r\n  display: flex;\r\n}\r\n\r\n.about__photo {\r\n  width: 583px;\r\n  height: 873px;\r\n  border-radius: 10px;\r\n  margin: 0 122px 0 0;\r\n}\r\n\r\n.about__info-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.about__paragraph {\r\n  font-size: 18px;\r\n  font-weight: 500;\r\n  line-height: 30px;\r\n  margin: 0 0 120px 0;\r\n  padding: 0;\r\n}\r\n\r\n.about__list {\r\n  list-style-image: url(\"../../images/list-bullet.svg\");\r\n  margin: 0;\r\n  padding: 0;\r\n  font-size: 20px;\r\n  font-weight: normal;\r\n  line-height: 28px;\r\n  margin: 0 0 0 28px;\r\n  padding: 0;\r\n}\r\n\r\n.about__list-item {\r\n  margin: 0 0 25px 0px;\r\n  padding-left: 40px;\r\n}\r\n\r\n.about__list-item:last-of-type {\r\n  margin-bottom: 0;\r\n}\r\n\r\n@media screen and (max-width: 1439px) {\r\n  .about {\r\n    padding: 100px 0 100px 0;\r\n  }\r\n\r\n  .about__container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n\r\n  .about__all-container {\r\n    max-width: 984px;\r\n  }\r\n\r\n  .about__header-container {\r\n    margin: 0 auto 50px 0;\r\n  }\r\n\r\n  .about__header {\r\n    font-size: 45px;\r\n    line-height: 55px;\r\n  }\r\n\r\n  .about__line {\r\n    width: 387px;\r\n    margin: 30px 0 0 0;\r\n  }\r\n\r\n  .about__photo {\r\n    width: 783px;\r\n    height: 845px;\r\n    object-fit: cover;\r\n    border-radius: 10px;\r\n    margin: 0 auto 32px auto;\r\n  }\r\n\r\n  .about__info-container {\r\n    align-items: center;\r\n  }\r\n\r\n  .about__paragraph {\r\n    max-width: 660px;\r\n    line-height: 26px;\r\n    margin: 0 0 37px 0;\r\n    text-align: center;\r\n  }\r\n\r\n  .about__list {\r\n    max-width: 641px;\r\n    font-size: 18px;\r\n    line-height: 26px;\r\n    margin: 0 0 0 28px;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 1023px) {\r\n  .about {\r\n    padding: 75px 0 75px 0;\r\n  }\r\n\r\n  .about__all-container {\r\n    max-width: 708px;\r\n  }\r\n\r\n  .about__header-container {\r\n    margin: 0 auto 35px 0;\r\n  }\r\n\r\n  .about__header {\r\n    font-size: 35px;\r\n    line-height: 45px;\r\n  }\r\n\r\n  .about__photo {\r\n    width: 500px;\r\n    height: 550px;\r\n    object-fit: cover;\r\n    border-radius: 10px;\r\n    margin: 0 auto 32px auto;\r\n  }\r\n\r\n  .about__paragraph {\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    margin: 0 0 30px 0;\r\n    text-align: center;\r\n  }\r\n\r\n  .about__list {\r\n    font-size: 16px;\r\n    line-height: 18px;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 763px) {\r\n  .about {\r\n    padding: 100px 0 100px 0;\r\n  }\r\n\r\n  .about__container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n\r\n  .about__all-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    max-width: 290px;\r\n    margin: 0 auto 0 auto;\r\n  }\r\n\r\n  .about__header-container {\r\n    margin: 0 auto 35px 0;\r\n  }\r\n\r\n  .about__header {\r\n    font-size: 26px;\r\n    line-height: 36px;\r\n    margin: 0 37px 0 0;\r\n  }\r\n\r\n  .about__line {\r\n    width: 150px;\r\n    margin: 18px 0 0 0;\r\n  }\r\n\r\n  .about__photo {\r\n    object-fit: cover;\r\n    width: 247px;\r\n    height: 312px;\r\n    margin: 0 0 41px 0;\r\n  }\r\n\r\n  .about__container {\r\n    flex-direction: column;\r\n  }\r\n\r\n  .about__paragraph {\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    line-height: 24px;\r\n    margin: 0 0 30px 0;\r\n  }\r\n\r\n  .about__list {\r\n    list-style-image: url(\"../../images/list-bullet-small.svg\");\r\n    font-size: 16px;\r\n    line-height: 24px;\r\n    margin: 0 0 0 18px;\r\n  }\r\n\r\n  .about__list-item {\r\n    margin: 0 0 10px 0px;\r\n    padding-left: 30px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
